import { Box, Chip, Grid, Tooltip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";
import { Template } from "features/Influencer/ContactList/schema";
import { trackEvent } from "utils/tracking";

import TemplateChip from "./TemplateChip";
import styles from "./styles";

interface Props {
  isFallback?: boolean;
  editDefault: () => void;
  fallbackTemplates: Template[];
}

const DefaultNicheCard = ({
  isFallback,
  editDefault,
  fallbackTemplates,
}: Props) => {
  return (
    <Box
      sx={styles.card}
      onClick={() => {
        trackEvent("VA Onboarding - Edit Fallback Templates Clicked");
        editDefault();
      }}
    >
      <Box sx={{ position: "absolute", top: 16, right: 16 }}>
        <Box
          component="i"
          className="fa-regular fa-pen"
          sx={{ color: grey[600], fontSize: 14 }}
        />
      </Box>
      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <Chip
          sx={{
            backgroundColor: "#e5eceb",
            fontSize: 14,
            px: 1,
          }}
          label={"General Use Template"}
        />

        {isFallback && (
          <Tooltip
            enterTouchDelay={0}
            onClick={(e) => e.stopPropagation()}
            slotProps={{
              tooltip: {
                sx: {
                  color: "black",
                  backgroundColor: "white",
                  border: "1px solid black",
                  borderRadius: 2,
                  p: 2,
                  fontSize: 14,
                },
              },
            }}
            title={
              <>
                <strong>General Use Templates</strong> are used when a brand
                doesn't fall into any of the specific niches listed above. For
                example, if you save a brand for your Virtual Assistant to
                contact and it doesn't match any of the predefined niches, this
                general template will automatically be used.
              </>
            }
          >
            <Box
              sx={{ ml: 1, color: "green.main" }}
              component="i"
              className="fa-solid fa-question-circle"
            />
          </Tooltip>
        )}
      </Grid>
      <Box>
        {fallbackTemplates?.map((template, index) => (
          <TemplateChip key={template.id} template={template} index={index} />
        ))}
        {fallbackTemplates?.length === 0 && (
          <>
            <Typography>No templates set.</Typography>

            <StyledLargeButton styles={{ mt: 2 }} fullWidth>
              Set your template
            </StyledLargeButton>
          </>
        )}
      </Box>
    </Box>
  );
};

export default DefaultNicheCard;
